import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {FullServicePackageConfigEditComponent} from '../../components/DomainDataEdit/FullServicePackageConfigEdit.component';

//base
import { BaseDomainDataGridComponent }         from '../../baseclasses/BaseDomainDataGrid';

@Component({
  selector: 'my-fullservicepackageconfig-grid',
  templateUrl: './FullServicePackageConfigGrid.component.html'
})
export class FullServicePackageConfigGridComponent extends BaseDomainDataGridComponent {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(FullServicePackageConfigEditComponent) recordEditComponent: FullServicePackageConfigEditComponent;

    userInfo: ent.UserInfo;
    records: ent.PackageConfig[];
    selectedRecords: ent.PackageConfig[] = [];
    editedRecord: ent.PackageConfig;
    cols: any[];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService,
         private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        this.editedRecord = new ent.PackageConfig();
        this.recordEditComponent.fullServiceCustomerTypeDropdownComponent.load();
        this.recordEditComponent.vendPackageDropdownComponent.load();
        this.loadColumns();
        this.onSearchClick(null);
        
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'VendPackage.Name', header: 'Package' },
            { field: 'FullServiceCustomerType.Name', header: 'Customer Type' },
            { field: 'PerformanceBasedPay', header: 'Performance Based Pay' },
            { field: 'CommissionRate', header: 'Commission Rate' },
            { field: 'MinimumVendPrice', header: 'Minimum Vend Price' }
        ];
    }

    onSearchClick(event: any){
        this.domainDataService.getFullServicePackageConfigs().subscribe(x=>{this.records = x});
    }

    onAddClick(event: any){
        this.editedRecord = new ent.PackageConfig();
        this.recordEditComponent.fullServiceCustomerTypeDropdownComponent.value = null;
        this.recordEditComponent.vendPackageDropdownComponent.value = null;
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, config: ent.PackageConfig){
        this.editedRecord = config;
        this.recordEditComponent.fullServiceCustomerTypeDropdownComponent.value = config.CustomerTypeID;
        this.recordEditComponent.vendPackageDropdownComponent.value = config.PackageID;
        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        if (this.editedRecord.PerformanceBasedPay === true){
            this.editedRecord.CommissionRate = null;
        }

        var request: ent.SavePackageConfigRequest = {PackageConfig: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        
        this.domainDataService.savePackageConfig(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }

    showCommissionRate(record: ent.PackageConfig): boolean{
        return record.PerformanceBasedPay == null || record.PerformanceBasedPay == false;
      }
}